import React from 'react'
import Layout from '../../Layout'
import CreateDiscountCodeContainer from '../../../../Components/DiscountPart/CreateDiscountCodeContainer/CreateDiscountCodeContainer'

const CreateDiscountCode = () => {
  return (
    <Layout>
      <CreateDiscountCodeContainer/>
    </Layout>
  )
}

export default CreateDiscountCode 